import { DOCUMENT } from '@angular/common';
import type { OnDestroy, OnInit } from '@angular/core';
import { Component, Inject, Renderer2 } from '@angular/core';

import { Subject } from 'rxjs';

import { PlatformThemeService } from '@core/user-interface-legacy';

import { AppInitializationService } from './app-initialization.service';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'rtr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private appInitializationService: AppInitializationService,
    private themeSrvc: PlatformThemeService,
  ) {
    this.renderer.addClass(document.body, `browser-${this.themeSrvc.resolveBrowserClassname()}`);
  }

  public ngOnInit(): void {
    this.appInitializationService.init();
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
